module.exports = __webpack_public_path__ + "090d2adafa4c463cfe48fe9de28f91c1.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/rockers.jpg
 ** module id = 427
 ** module chunks = 0
 **/